// extracted by mini-css-extract-plugin
module.exports = {"hidden":"EmailCapture_hidden__fCpKE","thankYou":"EmailCapture_thankYou__k2cy_"};